module.exports = __webpack_public_path__ + "media/bootstrap-icons/bookmark-heart-15d4b5f2.svg";